import SecondStepLogoIcon from './component.jsx'
export default SecondStepLogoIcon
